import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/ski-gear-storage.jpg'),
    alt: 'ski gear storage page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'ski gear storage page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Ski Gear <span>Storage</span> <span>The Best Solution for Ski Enthusiasts</span>',
  description:
    'Discover ShipAndStorage’s premium Ski Gear Storage services, offering convenience, security, and year-round accessibility for your ski equipment.',
  image: {
    url: '/images/v2/pages/main-pages/ski-gear-storage/hero-image.jpg',
    alt: 'Ski Gear Storage The Best Solution for Ski Enthusiasts'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Store Your Ski Gear' }
}

export const whyWeSectionContent = {
  title: 'How to Store Your Ski Gear with ShipAndStorage',
  description: 'Storing your ski gear is simple and efficient with our streamlined process. ',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Book Now' },

  cards: [
    {
      id: 1,
      title: 'Create an Account',
      description: 'Sign up on our platform and access tailored Ski Gear Storage solutions. ',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/create-an-account.png',
        alt: 'Create an Account'
      }
    },
    {
      id: 2,
      title: 'Prepare Your Equipment',
      description: 'Clean and securely pack your gear to ensure its protection during transit.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/prepare-your-equipment.png',
        alt: 'Prepare Your Equipment'
      }
    },
    {
      id: 3,
      title: 'Schedule Pickup or Drop-Off',
      description: 'Choose the most convenient option to deliver your ski gear to our facility.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/schedule-pickup-or-drop-off.png',
        alt: 'Schedule Pickup or Drop-Off'
      }
    },
    {
      id: 4,
      title: 'Relax and Access Anytime',
      description: 'Your equipment is stored safely and remains accessible whenever you need it.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/relax-and-access-anytime.png',
        alt: 'Relax and Access Anytime'
      }
    }
  ]
}

export const serviceTipsSectionContent = {
  title: 'Why Proper Ski Gear Storage Matters',
  description: 'Ensuring your ski gear is stored correctly is essential for maintaining its condition and longevity. ',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Get Your Storage' },

  cards: [
    {
      id: 1,
      title: 'Maintain Equipment',
      description: 'Proper ski gear storage is crucial to maintain your equipment’s condition and extend its lifespan.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/maintain-equipment.png',
        alt: 'Maintain Equipment'
      }
    },
    {
      id: 2,
      title: 'Prevent Damage',
      description:
        'Prevent damage from improper handling or environmental factors by ensuring your gear is stored away.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/prevent-damage.png',
        alt: 'Prevent Damage'
      }
    },
    {
      id: 3,
      title: 'Optimize Space',
      description:
        'Utilize dedicated storage solutions to optimize space and declutter your home or garage effectively.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/optimize-space.png',
        alt: 'Optimize Space'
      }
    },
    {
      id: 4,
      title: 'Seasonal Storage',
      description:
        'Safely store skis and snowboards during the off-season for convenience and to prevent unnecessary wear.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/seasonal-storage.png',
        alt: 'Seasonal Storage'
      }
    },
    {
      id: 5,
      title: 'Easy Retrieval',
      description:
        'Retrieve your gear quickly without hassle by keeping everything organized and easily accessible when needed.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/easy-retrieval.png',
        alt: 'Easy Retrieval'
      }
    },
    {
      id: 6,
      title: 'Protect Your Gear',
      description:
        'Protect your investment by following best practices for ski gear storage to enjoy the slopes worry-free.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/protect-your-gear.png',
        alt: 'Protect Your Gear'
      }
    }
  ]
}

export const typesOfSkiSectionContent = {
  title: 'Types of Ski Gear We Store',
  description: 'We cater to ski enthusiasts by offering storage solutions for various ski equipment, including:',

  cards: [
    {
      id: 1,
      title: 'Skis and Snowboards',
      description: 'Protect your skis and snowboards from damage with our secure and climate-controlled storage.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/skis-and-snowboards.png',
        alt: 'Skis and Snowboards'
      }
    },
    {
      id: 2,
      title: 'Ski Boots and Bindings',
      description: 'Keep your ski boots in top condition, ensuring they are ready for your next adventure.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/ski-boots-and-bindings.png',
        alt: 'Ski Boots and Bindings'
      }
    },
    {
      id: 3,
      title: 'Poles and Accessories',
      description: 'Store ski poles, helmets, goggles, and other essential accessories safely and efficiently.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/poles-and-accessories.png',
        alt: 'Poles and Accessories'
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose Us for Your Ski Gear Storage?',

  cards: [
    {
      id: 1,
      title: 'Flexible Storage Options',
      description:
        'Pay only for what you need with transparent pricing and choose between short-term or long-term plans without hidden fees.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/flexible-storage-options.png',
        alt: 'Flexible Storage Options'
      }
    },
    {
      id: 2,
      title: 'Secure Facilities',
      description:
        'Benefit from climate-controlled storage that prevents damage, secured by 24/7 monitoring and advanced security systems.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/secure-facilities.png',
        alt: 'Secure Facilities'
      }
    },
    {
      id: 3,
      title: 'Convenient Accessibility',
      description:
        'Easily retrieve your gear with flexible options, plus enjoy shipping services that deliver directly to your home.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/convenient-accessibility.png',
        alt: 'Convenient Accessibility'
      }
    },
    {
      id: 4,
      title: 'Expert Support',
      description:
        'Get personalized assistance for oversized or delicate equipment and receive professional packing tips.',
      image: {
        src: '/images/v2/pages/main-pages/ski-gear-storage/expert-support.png',
        alt: 'Expert Support'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Convenient Ski Gear Storage Solutions',
  description:
    'Store your ski gear with us for a seamless and stress-free experience. Ship your skis, boots, and snowboards to our secure facility and enjoy a clutter-free home.',
  image: {
    src: '/images/v2/pages/main-pages/ski-gear-storage/convenient-ski-gear-storage-solutions.png',
    alt: 'Convenient Ski Gear Storage Solutions'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Store With Us' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'What types of ski gear can I store?',
      answer: 'We accommodate a wide range of ski equipment, including skis, boots, snowboards, poles, and more.'
    },
    {
      id: 2,
      question: 'Is my equipment safe in storage?',
      answer: 'Yes, our facilities are climate-controlled and monitored 24/7 to ensure the highest level of security.'
    },
    {
      id: 3,
      question: 'Can I access my equipment anytime?',
      answer: 'Absolutely! Your gear remains accessible whenever you need it.'
    },
    {
      id: 4,
      question: 'Do you offer pickup and delivery?',
      answer: 'Yes, we provide convenient pickup and delivery options to make storage hassle-free.'
    },
    {
      id: 5,
      question: 'How much does ski gear storage cost?',
      answer: 'Pricing varies based on the duration and type of gear stored. Contact us for a personalized quote.'
    }
  ]
}
